<template>
  <div>
    <a-card>
      <a-form layout="inline" style="margin-bottom:40px">
        <a-row :gutter="20" >
          <a-col :span="8">
            <a-form-item label="师傅信息">
              <a-input
                placeholder="电话/名称"
                v-model.trim="time.masterInfo"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" >
            <a-form-item label="充值时间">
              <a-range-picker
                :show-time="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                format="YYYY-MM-DD HH:mm:ss"
                @change="onChangeTime"
                style="width: 90%"
                v-model="time.dateString"
              />
            </a-form-item>
          </a-col>
          <a-col :span="4" >

            <a-button type="primary" class="mr-20" @click="query(1)">
              查找
            </a-button>
            <a-button type="primary" @click="empty()">
              清空
            </a-button>

          </a-col>
        </a-row>
      </a-form>
      <a-table :columns="columns" :data-source="data" bordered :pagination="false">
      </a-table>
      <a-pagination
        showQuickJumper="true"
        showSizeChanger
        :pageSizeOptions="pageSizeOptions"
        :pageSize.sync="pageSize"
        @showSizeChange="onShowSizeChange"
        :total="total"
        v-model="current"
        @change="getdataList"
        :showTotal="total => `总共 ${total} 条`"
        style="text-align: right; margin-top: 20px"
      />
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import { getMasterDepositList } from '@/api/finance/masterDeposit'
export default {
  data () {
    return {
      dateString: '', // 时间选择
      time: {
        masterInfo: '', // 师傅信息
        startTime: '', // 开始时间
        endTime: '' // 结束时间
      },
      columns: [
        {
          title: '姓名',
          dataIndex: 'masterName',
          align: 'center'

        },
        {
          title: '电话',
          dataIndex: 'masterPhone',
          align: 'center'
        },
        {
          title: '充值金额（元）',
          dataIndex: 'rechargeMoney',
          align: 'center'

        },
        {
          title: '充值方式',
          dataIndex: 'rechargeMethod',
          align: 'center'
        }, {
          title: '充值时间',
          dataIndex: 'rechargeTime',
          align: 'center'

        }, {
          title: '保证金金额',
          dataIndex: 'haveMoney',
          align: 'center'
        }
      ],
      data: [],
      current: 1,
      total: 0, // 总条数
      pageNum: 1,
      pageSize: '10',
      pageSizeOptions: ['10', '20', '30', '40']

    }
  },
  components: {

  },
  created () {
    this.getMasterDeposit()
  },
  mounted () {

  },
  methods: {
    moment,
    // 选择时间
    onChangeTime (date, dateString) {
      this.time.startTime = dateString[0]
      this.time.endTime = dateString[1]
    },
    // 清空
    empty () {
      this.dateString = ''
      this.time = {}
    },
    // 获取保证金列表
    async  getMasterDeposit () {
      try {
        const res = await getMasterDepositList({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          timeStart: this.time.startTime,
          timeEnd: this.time.endTime,
          masterMessage: this.time.masterInfo
        })
        this.data = res.rows
        this.total = res.total
      } catch (err) {
        console.log(err)
      }
    },
    // 分页
    onShowSizeChange (current, pageSize) {
      this.pageSize = pageSize
      this.getdataList(current)
    },
    getdataList (value) {
      this.current = value
      this.pageNum = value
      this.getMasterDeposit()
    },
    // 查找
    query (page) {
      if (page == 1) {
        this.pageNum = 1
        this.current = 1
      }
      this.getMasterDeposit()
    }
  }
}
</script>

<style scoped lang="less">

</style>
